import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
  },
  state: {
    img: '',
    nickname: '',
  },
  mutations: {
    getImg(state, img) {
      state.img = img;
    },
    getNickname(state, nickname) {
      state.nickname = nickname;
    },
  },
  actions: {
    getImgSync(context, img) {
      setTimeout(() => {
        context.commit('getImg', img);
      }, 3000);
    },

    getNicknameSync(context, nickname) {
      setTimeout(() => {
        context.commit('getNickname', nickname);
      }, 3000);
    },
  },
  getters: {
    ...getters,
    img: state => state.img,
    nickname: state => state.nickname,
  },
});
